import React, { cloneElement, useEffect, useRef, useState } from 'react';
import { getLabel } from '../data/labels';
import { getConfiguration } from '../data/utils/configuration';

export default function ButtonsScroller(props) {
    const [toggled, setToggled] = useState(false);
    const conf = getConfiguration();
    const ref = useRef(null);
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {

        const listener = () => setToggled(false);
        window.addEventListener('xs-close-buttons-scroller', listener);

        Array.from(ref.current?.children || [])?.forEach((c, i) => {
            if (c.selected) {
                ref.current.children[i]?.scrollIntoView(false); //Pass false to prevent y-scrolling when the height of <body> is greater than the height of window.appConfig['CONTAINER_ID']
            }
        })

        return () => window.removeEventListener('xs-close-buttons-scroller', listener);
    }, []);

    function toggle(i) {
        setToggled(!toggled);
        if (toggled && ref.current) {
            ref.current.children[i]?.scrollIntoView(false); //Pass false to prevent y-scrolling when the height of <body> is greater than the height of window.appConfig['CONTAINER_ID']
            setIsClosing(false)
        }
    }



    const scrollRef = useRef(null);
    const innerRef = useRef(null);

    const [showBottomShadow, setShowBottomShadow] = useState(false);
    const [isReadyForScrollCheck, setIsReadyForScrollCheck] = useState(false);

    useEffect(() => {
        if (!toggled && !conf.iwh) return;

        const scrollEl = scrollRef.current;
        const innerEl = innerRef.current;
        if (!scrollEl || !innerEl) return;

        const updateShadows = () => {
            const scrollTop = scrollEl.scrollTop;
            const scrollHeight = innerEl.offsetHeight;
            const clientHeight = scrollEl.clientHeight;

            const isScrollable = scrollHeight > clientHeight;
            if (!isScrollable) {
                setShowBottomShadow(false);
                return;
            }
            setShowBottomShadow(scrollTop + clientHeight < scrollHeight);
        };
        setIsReadyForScrollCheck(false);

        const timeout = setTimeout(() => {
            setIsReadyForScrollCheck(true);
            updateShadows();
            scrollEl.addEventListener("scroll", updateShadows);
            window.addEventListener("resize", updateShadows);
        }, 101);

        return () => {
            clearTimeout(timeout);
            scrollEl?.removeEventListener("scroll", updateShadows);
            window.removeEventListener("resize", updateShadows);
            setIsReadyForScrollCheck(false);
        };
    }, [toggled, conf.iwh]);

    return (
        <div className={`xs_buttonsScroller relative grid grid-cols-12 bg-cs1 ${props.currentView ? `currentView--${props.currentView}` : ''}`}>
            <div className="col-start-1 col-end-12 h-bets-navbar-height overflow-x-auto p-2 flex items-center bg-cs1 font-medium text-xs uppercase" ref={ref}>
                {props.children}
            </div>
            <div className="col-start-12 col-end-13 flex items-center justify-center" onClick={toggle}>
                <div className="p-1 bg-cs4 text-cs1 rounded-lg toggleButtonScrollerClose">
                    {toggled ?
                        <i className="bi-chevron-up" />
                        :
                        <i className="bi-chevron-down" />
                    }
                </div>
            </div>

            {toggled && conf.iwh &&
                <div className={`btnScroller-pre drawer drawer--bottom ${isClosing && ' drawer--closing '}`} aria-labelledby={getLabel('general.choose_selection')} role="dialog" aria-modal="true">
                    <div onClick={toggle} className="drawer__backdrop"></div>
                    <div className="drawer__content" ref={scrollRef} >
                        <div className="drawer__content__outer  " >
                            <div className="drawer__content__inner" ref={innerRef}>
                                <div className="bg-white  pb-4 pt-5 sm:p-6 sm:pb-4 ">
                                    <div className="sm:flex sm:items-start">
                                        <div className='flex justify-between px-4 pb-5 sticky top-0 z-50 bg-white '>
                                            <div><h2 className='label__txt--1 text-[18px] font-[600]'>{getLabel('general.choose_selection')}</h2></div>
                                            <div><button onClick={() => toggle()} className='label__btn--3  text-[14px] font-[600]'>{getLabel('general.close')}</button></div>
                                        </div>
                                        <ul>
                                            {props.children.map((e, i) => {
                                                return <div key={i} className='w-full modalBottom__wh' onClick={({ ...params }) => {
                                                    e.props.onClick(params);
                                                    toggle(i);
                                                }}  ><li className="list-btn-wh w-full relative cursor-default select-none py-[12px] pl-3 pr-9 text-gray-900" id="listbox-option-0" role="option">
                                                        <div className="flex items-center w-full">
                                                            <span className="w-full items__dropdown block truncate font-semibold">{e}</span>
                                                        </div>
                                                        <span className="check_is_selected absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
                                                            <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M11.7727 1.07023L11.578 0.876224C11.4266 0.725714 11.2425 0.650024 11.0265 0.650024C10.8105 0.650024 10.6268 0.725714 10.4753 0.876224L4.36364 6.96883L1.52509 4.13872C1.37324 3.98821 1.18953 3.91252 0.973527 3.91252C0.757091 3.91252 0.572945 3.98821 0.421527 4.13916L0.226909 4.33317C0.0759273 4.48455 0 4.66768 0 4.88301C0 5.09833 0.0759273 5.28147 0.226909 5.43242L3.50007 8.92982L3.69469 9.12383C3.84655 9.27433 4.03025 9.35003 4.24625 9.35003C4.46225 9.35003 4.64596 9.27433 4.79738 9.12383L11.7731 2.17035C11.9241 2.01897 12 1.83627 12 1.62051C12 1.40475 11.9241 1.22161 11.7727 1.07023Z" fill="#00143C" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                </div>
                                            })}
                                        </ul>
                                    </div>
                                    {isReadyForScrollCheck && showBottomShadow &&
                                        <div className="arrowDown__wrapper">
                                            <div className="arrowDown__scroll"></div>
                                            <div className="arrowDown__scroll delay"></div>
                                        </div>
                                    }
                                    {isReadyForScrollCheck && showBottomShadow && <div className="drawer__shadow--bottom" />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {toggled && !conf.iwh &&
                <div className="z-30 absolute top-0 left-0 right-0 flex flex-col p-1 bg-cs1 shadow-sm shadow-shadow">
                    <div className="flex items-center justify-between mb-1" onClick={toggle}>
                        <span className="font-medium text-sm uppercase mx-auto">{getLabel('general.choose_selection')}</span>
                        <div className="p-1 bg-cs4 text-cs1 rounded-lg toggleButtonScrollerOpen">
                            <i className="bi-x-lg" />
                        </div>
                    </div>
                    <div className="xs_scrollerGrid max-h-[300px] overflow-y-auto pb-16 grid grid-cols-2 gap-2 font-medium text-xs uppercase">
                        {props.children.map((b, i) => {
                            const cloned = cloneElement(b, {
                                onClick: ({ ...params }) => {
                                    b.props.onClick(params);
                                    toggle(i);
                                }
                            });
                            return cloned;
                        })}
                    </div>
                </div>
            }
        </div>
    );
}
